/**
 * ════════════════════════════════════════════════════════════════════
 *  KINGZ.COM — PHASE 2, FIX 7: INTERSECTION OBSERVER LAZY LOADERS
 *  File: assets/kingz-lazy-widgets.js
 *  Updated: 2026-07-02
 *
 *  CHANGES FROM PREVIOUS VERSION:
 *  1. Fixed fallback logic — observer no longer initialises on browsers
 *     that don't support IntersectionObserver (was running both paths).
 *  2. Added auto-detection of .jdgm-review-widget elements on product
 *     pages so Judge.me loads without requiring data-lazy-widget in HTML.
 * ════════════════════════════════════════════════════════════════════
 */

(function() {
  'use strict';

  var OBSERVER_OPTIONS = {
    root:       null,
    rootMargin: '400px',
    threshold:  0,
  };

  // ── JUDGE.ME LAZY LOADER ─────────────────────────────────────────
  function lazyLoadJudgeMe(container) {
    var JUDGEME_SCRIPT_ID = 'judgeme-widget-script';
    if (document.getElementById(JUDGEME_SCRIPT_ID)) return;
    var script = document.createElement('script');
    script.src   = 'https://cdn.judge.me/shopify_widgets/apps.js';
    script.id    = JUDGEME_SCRIPT_ID;
    script.async = true;
    if (window.Shopify && window.Shopify.shop) {
      script.setAttribute('data-shop-domain', window.Shopify.shop);
    }
    script.addEventListener('load', function() {
      console.log('[Kingz] Judge.me reviews loaded as section entered viewport.');
    });
    document.head.appendChild(script);
  }

  // ── GENERIC WIDGET LOADER ────────────────────────────────────────
  function lazyLoadGenericScript(container) {
    var scriptUrl = container.dataset.lazyScript;
    var scriptId  = container.dataset.lazyId || 'lazy-script-' + Date.now();
    if (!scriptUrl || document.getElementById(scriptId)) return;
    var script = document.createElement('script');
    script.src   = scriptUrl;
    script.id    = scriptId;
    script.async = true;
    script.addEventListener('load', function() {
      console.log('[Kingz] Lazy script loaded:', scriptId);
    });
    document.head.appendChild(script);
  }

  // ── DISPATCH BASED ON TYPE ───────────────────────────────────────
  function handleElement(el) {
    var type = el.dataset.lazyWidget;
    if (type === 'judgeme')  lazyLoadJudgeMe(el);
    if (type === 'generic')  lazyLoadGenericScript(el);
  }

  // ── COLLECT ALL TARGETS ──────────────────────────────────────────
  // Includes explicit [data-lazy-widget] elements AND auto-detected
  // Judge.me containers on product pages (no HTML changes required).
  function collectTargets() {
    var targets = Array.from(document.querySelectorAll('[data-lazy-widget]'));

    // ADDED: auto-detect Judge.me widget containers on product pages
    document.querySelectorAll('.jdgm-review-widget, .jdgm-widget, #jdgm-widget').forEach(function(el) {
      if (!el.dataset.lazyWidget) {
        el.dataset.lazyWidget = 'judgeme';
        targets.push(el);
      }
    });

    return targets;
  }

  var targets = collectTargets();

  // FIXED: observer only initialises if IntersectionObserver is supported.
  // Fallback runs immediately for browsers that don't support it.
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        handleElement(entry.target);
        obs.unobserve(entry.target);
      });
    }, OBSERVER_OPTIONS);

    targets.forEach(function(el) {
      observer.observe(el);
    });

  } else {
    // Fallback: load everything immediately on unsupported browsers
    targets.forEach(function(el) {
      handleElement(el);
    });
  }

  console.log('[Kingz] Intersection Observer lazy widget loader initialized. Watching ' + targets.length + ' elements.');

})();